
import uiRouterModule from "@uirouter/angularjs";
import TbAuthServiceModule from "tbClient/services/auth";

import TbLoginViewModuleConstants from "tbClient/views/tb-login-view/Constants";

function HandleAuthenticationHook($transitions, $log) {
    const doHandleAuthentication = (transition) => {
        const authSvc = transition.injector().get("TbAuthService");
        $log.debug("Running Handle Authentication Hook");

        // If the user already has valid tokens  
        if (authSvc.isAuthenticated()) {
            $log.debug("Handle Authentication: Valid tokens already exist, skipping callback parsing.");
            return;
        }

        return authSvc.handleAuthentication()
            .catch((err) => {
                let targetParams = {};
                
                if (err && (typeof(err.error) === "string") && (typeof(err.errorDescription) === "string")) {
                    $log.error("Error occurred handling authentication. redirecting to login page.", err);
                    // Handle structured auth errors
                    if (err.error === "access_denied") {
                        targetParams = {
                            reason: "denied",
                            message: "Access denied. You may not have permission to access this application."
                        };
                    }
                }
                else if (err && err.message && err.message.includes("access_denied")) {
                    $log.error("OneLogin access denied error. Redirecting to login page with context.", err);
                    targetParams = {
                        reason: "denied", 
                        message: "Access denied. You may not have permission to access this application or your account may be inactive."
                    };
                }
                else {
                    $log.error("A unknown error occurred handling authentication. Redirecting to login page", err);
                    targetParams = {
                        reason: "error",
                        message: "An authentication error occurred. Please try signing in again."
                    };
                }

                return transition.router.stateService.target(TbLoginViewModuleConstants.rootStateName, targetParams);
            });
    };

    const ignoreLoginStateCriteria = {
        to: (state) => (state.name !== TbLoginViewModuleConstants.rootStateName)
    };

    $transitions.onBefore(ignoreLoginStateCriteria, doHandleAuthentication, {
        invokeLimit: 1,
        priority: 200
    });
}

HandleAuthenticationHook.$inject = [ "$transitions", "$log" ];
HandleAuthenticationHook.dependencies = [
    uiRouterModule,
    TbAuthServiceModule
];

export default HandleAuthenticationHook;



//////////////////
// WEBPACK FOOTER
// ./src/hooks/HandleAuthenticationHook.js
// module id = YKrq
// module chunks = 1